import { isNaN, isNumber, toNumber } from "lodash-es";

// 通过文件名对应文件类型
export const FILE_TYPE_LIST = [
  {
    type: "img",
    regexp: /\S+\.(a?png|jpe?g|gif|bmp|svg|webp)$/i,
    src: require("@/CommonDP/assets/projectMg/img.svg")
  },
  {
    type: "ppt",
    regexp: /\S+\.pptx?$/i,
    src: require("@/CommonDP/assets/projectMg/ppt.svg")
  },
  {
    type: "word",
    regexp: /\S+\.docx?$/i,
    src: require("@/CommonDP/assets/projectMg/doc.svg")
  },
  {
    type: "excel",
    office: 2,
    regexp: /\S+\.xlsx?$/i,
    src: require("@/CommonDP/assets/projectMg/xls.svg")
  },
  {
    type: "zip",
    regexp: /\S+\.(zip|rar)$/i,
    src: require("@/CommonDP/assets/projectMg/zip.svg")
  },
  {
    type: "pdf",
    regexp: /\S+\.pdf$/i,
    src: require("@/CommonDP/assets/projectMg/pdf.svg")
  },
  {
    type: "txt",
    regexp: /\S+\.txt$/i,
    src: require("@/CommonDP/assets/projectMg/txt.svg")
  },
  {
    type: "video",
    regexp: /\S+\.(ogg|mp4|webm|avi)$/i,
    src: require("@/CommonDP/assets/projectMg/video.svg")
  },
  {
    type: "rvt",
    regexp: /\S+\.rvt$/i,
    src: require("@/CommonDP/assets/projectMg/rvt.svg")
  },
  {
    type: "dwg",
    regexp: /\S+\.dwg$/i,
    src: require("@/CommonDP/assets/projectMg/dwg.svg")
  },
  {
    type: "audio",
    regexp: /\S+\.(mp3|wav)$/i,
    src: require("@/CommonDP/assets/projectMg/audio.svg")
  },
  {
    type: "3dm",
    regexp: /\S+\.3dm$/i,
    src: require("@/CommonDP/assets/projectMg/3dm.svg")
  },
  {
    type: "skp",
    regexp: /\S+\.skp$/i,
    src: require("@/CommonDP/assets/projectMg/skp.svg")
  },
  {
    type: "rfa",
    regexp: /\S+\.rfa$/i,
    src: require("@/CommonDP/assets/projectMg/rfa.svg")
  },
  {
    type: "fbx",
    regexp: /\S+\.fbx$/i,
    src: require("@/CommonDP/assets/projectMg/fbx.png")
  },
  {
    type: "obj",
    regexp: /\S+\.obj$/i,
    src: require("@/CommonDP/assets/projectMg/obj.svg")
  },
  {
    type: "glb",
    regexp: /\S+\.glb$/i,
    src: require("@/CommonDP/assets/projectMg/glb.svg")
  },
  {
    type: "nwf",
    regexp: /\S+\.nwf$/i,
    src: require("@/CommonDP/assets/projectMg/nwf.svg")
  },
  {
    type: "other",
    regexp: /.+/i,
    src: require("@/CommonDP/assets/projectMg/dll.svg")
  }
];

/**
 * @param {string} fileName 文件名称
 * @returns {string} 资源路径
 */
export const getFileIconByName = (fileName) => {
  if (fileName) {
    for (const { $icon, regexp, src } of FILE_TYPE_LIST) {
      if ($icon) return $icon;
      else if (regexp.test(fileName)) return src;
    }
  }
  return "";
};
/**
 * @type {import("vue").Directive<Element,{fileName:string}>}
 */
export const fileDirective = (el, { value: { fileName, folderName, isFolder }}) => {
  el.src = isFolder ? require('@/CommonDP/assets/projectMg/folder.svg') : getFileIconByName(fileName || folderName);
};
/**
 * @description 输出友好的文件大小单位
 * @param {number} size
 * @returns {string}
 */
export function fileSize(size = 0) {
  const types = ["B", "KB", "M", "G", "T"];
  let currentSize = toNumber(size);
  if (isNaN(currentSize)) return '0B';
  let index = 0;
  for (; index < types.length && currentSize > 1000; index++) {
    currentSize /= 1024;
  }
  return currentSize ? +currentSize.toFixed(2) + types[index] : "";
}
